import React from 'react';
import * as Ons from 'react-onsenui';
import dateFormat from 'date-format';
import PlayerImage from '../PlayerImage';
import { coloredLabel } from '../../util';
import { translate as _ } from '../../util/i18n';

class Player extends React.Component {

    #styles = [ 'bold', 'centered', 'fixed', 'large', 'xlarge', 'upper', 'inverted' ];

    constructor( props ) {

        super( props );

        this.handleActivate      = this.handleActivate.bind( this );
        this.handleClick         = this.handleClick.bind( this );
        this.handleJerseyNrClick = this.handleJerseyNrClick.bind( this );

    }

    handleActivate( e ) {

        if ( this.props.onActivate ) {

            e && e.stopPropagation();

            this.props.onActivate( this.props.player );

        }

    }

    handleClick() {

        this.props.onClick && this.props.onClick( this.props.player );

    }

    handleJerseyNrClick() {

        this.props.onJerseyNrClick && this.props.onJerseyNrClick( this.props.player );

    }

    formatLine( line, i ) {

        return <div className="line" key={i}>{line.map( ( pattern, i ) => this.formatValue( pattern, i ) )}</div>;

    }

    formatValue( pattern, i ) {

        if ( ! ( pattern.key in this.props.player ) ) {

            return '';

        }

        let className = [],
            value     = this.props.player[ pattern.key ];

        if ( ! value ) {

            pattern.type !== 'jerseyNr' && className.push( 'no-value' );

        } else if ( typeof value === 'string' ) {

            value = value.split( '#' )[ 0 ];

        }

        if ( pattern.type === 'yob' && value ) {

            value = ( new Date( value ) ).getFullYear();

        } else if ( pattern.type === 'dob' && value ) {

            value = dateFormat.asString( 'dd.MM.yy', new Date( value ) );

        } else if ( pattern.type === 'weight' ) {

            value += 'kg';

        } else if ( pattern.type === 'height' ) {

            value += 'cm';

        } else if ( pattern.type === 'jerseyNr' ) {

            className.push( 'jersey-nr' );

        }

        if ( pattern.style ) {

            const style = pattern.style.split( ',' );

            if ( style.indexOf( 'label' ) !== -1 ) {

                value = coloredLabel( value );

            }

            this.#styles.forEach( e => style.indexOf( e ) !== -1 && className.push( e ) );

        }

        return <span className={className.join( ' ' )} key={i} data-key={pattern.key}>{value}</span>;

    }

    render() {

        const playerClass = [ 'player' ];

        if ( this.props.player.isExtended                                                         ) { playerClass.push( 'is-extended'     ); }
        if ( this.props.player.isSuspended                                                        ) { playerClass.push( 'is-suspended'    ); }
        if ( this.props.player.locallyChanged                                                     ) { playerClass.push( 'locally-changed' ); }
        if ( this.props.player.position && this.props.player.position.indexOf( '#DNP'    ) !== -1 ) { playerClass.push( 'dnp'             ); }
        if ( this.props.player.position && this.props.player.position.indexOf( '#ABSENT' ) !== -1 ) { playerClass.push( 'absent'          ); }

        return (

            <Ons.ListItem key={this.props.player.id} modifier={this.props.modifier} tappable={true} onClick={this.handleClick} className={playerClass.join( ' ' )}>

                <div className="left">

                    <PlayerImage
                        activatable={this.props.activatable}
                        isActive={this.props.isActive}
                        player={this.props.player}
                        onJerseyNrClick={this.handleJerseyNrClick}
                        onToggle={this.handleActivate}
                        textActivate={this.props.textActivate}
                        textIsActive={this.props.textIsActive}
                        type={this.props.type}
                    />

                </div>

                <div className="center">

                    {this.props.format.map( ( line, i ) => this.formatLine( line, i ) )}

                    { this.props.player.isSuspended && <div className='line'><span className='label label-4'>{ _( 'Gesperrt' ) }</span></div> }

                </div>

                <div className="right" onClick={this.handleActivate}>{this.props.activatable && this.props.isActive ? <i className="fa fa-2x fa-check active-icon" /> : this.props.activatable && this.props.onActivate ? <i className="fa fa-2x fa-circle inactive-icon" /> : ''}</div>

            </Ons.ListItem>

        );

    }

}

export default Player;